// Size the upward-opening menu against the actual composer position, including
// resized windows, expanded input fields and the on-screen keyboard viewport.
export default {
  mounted () {
    this.resizeMenu = () => {
      const viewportTop = window.visualViewport?.offsetTop ?? 0
      const available = Math.max(0, this.el.getBoundingClientRect().top - viewportTop - 16)
      this.el.style.setProperty('--attachment-menu-height', `${available}px`)
    }
    this.el.addEventListener('focusin', this.resizeMenu)
    window.addEventListener('resize', this.resizeMenu)
    window.addEventListener('scroll', this.resizeMenu, true)
    window.visualViewport?.addEventListener('resize', this.resizeMenu)
    window.visualViewport?.addEventListener('scroll', this.resizeMenu)
    this.resizeObserver = new ResizeObserver(this.resizeMenu)
    this.resizeObserver.observe(this.el.closest('form') ?? this.el)
    this.resizeMenu()
  },
  updated () {
    this.resizeMenu()
  },
  destroyed () {
    this.el.removeEventListener('focusin', this.resizeMenu)
    window.removeEventListener('resize', this.resizeMenu)
    window.removeEventListener('scroll', this.resizeMenu, true)
    window.visualViewport?.removeEventListener('resize', this.resizeMenu)
    window.visualViewport?.removeEventListener('scroll', this.resizeMenu)
    this.resizeObserver.disconnect()
  }
}
